"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSType = exports.TSTypeAliasDeclaration = exports.TSTypeAliasDeclarationWithParams = exports.importDeclaration = exports.TSFile = void 0;
const t = require("@babel/types");
function TSFile(ast) {
    const body = ast.body.map(each => {
        switch (each.kind) {
            case "TypeVariableDeclaration": return TSTypeAliasDeclaration(each);
            case "TypeFunctionDeclaration": return TSTypeAliasDeclarationWithParams(each);
            case "ImportDeclaration": return importDeclaration(each);
            default:
                assertNever(each);
        }
    });
    const file = t.file(t.program(body));
    return file;
}
exports.TSFile = TSFile;
function importDeclaration(ast) {
    const specifiers = ast.specifiers.map(each => t.importSpecifier(Identifier(each.imported), Identifier(each.imported)));
    return t.importDeclaration(specifiers, t.stringLiteral(ast.source));
}
exports.importDeclaration = importDeclaration;
function TSTypeAliasDeclarationWithParams(ast) {
    const _type = TSTypeAliasDeclaration(ast);
    const type = t.isExportNamedDeclaration(_type) ? _type.declaration : _type;
    type.typeParameters = tsTypeParameterDeclaration(ast.declarator.initializer.params);
    return _type;
}
exports.TSTypeAliasDeclarationWithParams = TSTypeAliasDeclarationWithParams;
function TSTypeAliasDeclaration(ast) {
    const declarator = ast.declarator;
    const declaraion = t.tsTypeAliasDeclaration(Identifier(declarator.name), null, TSType(declarator.initializer));
    if (ast.export) {
        return t.exportNamedDeclaration(declaraion);
    }
    else {
        return declaraion;
    }
}
exports.TSTypeAliasDeclaration = TSTypeAliasDeclaration;
function tsConditionalType(ast) {
    const { condition, consequent, alternate } = ast;
    const falseType = alternate.kind === "TypeIfStatement" ? tsConditionalType(alternate) : TSType(alternate.argument);
    const type = t.tsConditionalType(TSType(condition.checkType), TSType(condition.extendsType), TSType(consequent.argument), falseType);
    return type;
}
function tsConstrucSignature(ast) {
    const name = ast.name;
    const params = tsFunctionParams(name.params);
    return t.tsConstructSignatureDeclaration(null, params, t.tsTypeAnnotation(TSType(ast.value)));
}
function tsCallSignature(ast) {
    const name = ast.name;
    const params = tsFunctionParams(name.params);
    return t.tsCallSignatureDeclaration(null, params, t.tsTypeAnnotation(TSType(ast.value)));
}
function tsPropertySignature(ast) {
    const key = Identifier(ast.name);
    const value = TSType(ast.value);
    const prop = t.tsPropertySignature(key, t.tsTypeAnnotation(value));
    return Object.assign(Object.assign({}, prop), { readonly: ast.readonly, optional: ast.optional });
}
function tsTypeLiteral(ast) {
    const props = ast.props.map(each => {
        switch (each.kind) {
            case "TypeObjectProperty": {
                switch (each.name.kind) {
                    case "Identifier": return tsPropertySignature(each);
                    case "CallSignature": return tsCallSignature(each);
                    case "ConstructSignature": return tsConstrucSignature(each);
                }
            }
            case "TypeSpreadProperty": {
                if (each.param.kind === "TypeReference") {
                    const type = TSType(each.param);
                    return type;
                }
                else if (each.param.kind === "TypeCallExpression") {
                    const typeName = Identifier(each.param.callee.typeName);
                    const params = each.param.params.map(each => {
                        if (each.kind === "TypeReference") {
                            return TSType(each);
                        }
                        throw new Error(`unkonwn param: ${JSON.stringify(each, null, 4)}`);
                    });
                    const typeReference = t.tsTypeReference(typeName, t.tsTypeParameterInstantiation(params));
                    return typeReference;
                }
            }
        }
    });
    const isSpread = ast.props.some(prop => prop.kind === "TypeSpreadProperty");
    if (isSpread) {
        const tsTypeProps = props.map(each => {
            if (t.isTSPropertySignature(each)) {
                return t.tsTypeLiteral([each]);
            }
            else {
                return each;
            }
        });
        const assigned = assignObjects(tsTypeProps);
        return assigned;
    }
    else {
        return t.tsTypeLiteral(props);
    }
}
function assignObjects(objects) {
    const name = t.identifier(TypeLibFunction.Object.Assign);
    const params = t.tsTypeParameterInstantiation([t.tsTypeLiteral([]), t.tsTupleType(objects)]);
    const assigned = t.tsTypeReference(name, params);
    return assigned;
}
/**
 * eg.
 * `a`
 * `${a}`
 * `${a}${b}`
 * `${a}b${c}`
 * `${a}b${c}d`
 * `a${b}c${d}e`
 */
function templateLiteral(ast) {
    const { items } = ast;
    const quasis = [];
    const expressions = [];
    items.forEach((each, index) => {
        if (each.kind === "TemplateElement") {
            quasis.push(t.templateElement({ raw: each.value }));
        }
        else if (each.kind === "TemplateExpression") {
            if (quasis.length === expressions.length) {
                quasis.push(t.templateElement({ raw: "" }));
            }
            expressions.push(TSType(each.expression));
            if (index === items.length - 1) {
                quasis.push(t.templateElement({ raw: "" }, true));
            }
        }
    });
    return t.templateLiteral(quasis, expressions);
}
function tsIndexedAccessType(head, members) {
    const indexType = TSType(members[members.length - 1]);
    if (members.length === 1) {
        const type = t.tsIndexedAccessType(TSType(head), indexType);
        return type;
    }
    else {
        const rest = members.slice(0, members.length - 1);
        const objectType = tsIndexedAccessType(head, rest);
        return t.tsIndexedAccessType(objectType, indexType);
    }
}
function tsIndexType(ast) {
    return tsIndexedAccessType(ast.head, ast.members);
}
function _tsArrayType(elementType, dimension) {
    if (dimension === 1) {
        return t.tsArrayType(elementType);
    }
    else {
        return t.tsArrayType(_tsArrayType(elementType, dimension - 1));
    }
}
function tsArrayType(ast) {
    return _tsArrayType(TSType(ast.elementType), ast.dimension);
}
function tsFunctionType(ast) {
    const params = tsFunctionParams(ast.params);
    const typeParams = ast.typeParams ? tsTypeParameterDeclaration(ast.typeParams) : null;
    const args = [typeParams, params, t.tsTypeAnnotation(TSType(ast.returnType))];
    const type = ast.isConstructor ? t.tsConstructorType(...args) : t.tsFunctionType(...args);
    return type;
}
function tsFunctionParams(params) {
    return params.map(each => {
        const identifier = Identifier(each.name);
        const param = each.rest ? t.restElement(identifier) : identifier;
        param.typeAnnotation = t.tsTypeAnnotation(TSType(each.type));
        if (each.optional) {
            param["optional"] = true;
        }
        return param;
    });
}
function tsTypeParameterDeclaration(params) {
    return t.tsTypeParameterDeclaration(params.map(param => tsTypeParameter(param)));
}
function tsTypeParameter(ast) {
    const constraint = ast.constraint ? TSType(ast.constraint) : null;
    const _default = ast.default ? TSType(ast.default) : null;
    const tsParam = t.tSTypeParameter(constraint, _default, ast.typeName.name);
    return tsParam;
}
function resolveMappedTypeAsClause(as, key) {
    if (as.value.kind === "TypeReference" && as.value.typeName.name === key.name) {
        return null;
    }
    return TSType(as.value);
}
function tsMappedType(ast) {
    const { as, key, keys, value } = ast;
    const typeParam = t.tsTypeParameter(TSType(keys), null, key.name);
    const nameType = resolveMappedTypeAsClause(as, key);
    const type = t.tsMappedType(typeParam, TSType(value), nameType);
    return Object.assign(Object.assign({}, type), { readonly: as.readonly, optional: as.optional });
}
function tsTypeOperator(ast, operator) {
    return Object.assign(Object.assign({}, t.tsTypeOperator(TSType(ast.operand))), { operator }); /** TODO: use t.tsTypeOperator to create it? */
}
function TSType(ast) {
    switch (ast.kind) {
        /**
         */
        case "StringTypeLiteral": return t.tsLiteralType(Object.assign(Object.assign({}, t.stringLiteral(ast.value)), { extra: {
                raw: `"${ast.value}"`,
                rawValue: ast.value
            } }));
        case "NumberTypeLiteral": return t.tsLiteralType(t.numericLiteral(ast.value));
        case "BooleanTypeLiteral": return t.tsLiteralType(t.booleanLiteral(ast.value));
        case "TemplateTypeLiteral": return {
            type: "TSLiteralType",
            literal: templateLiteral(ast)
        }; /** TODO: use t.tsLiteralType to create it */
        /**
         */
        case "StringType": return t.tsStringKeyword();
        case "NeverType": return t.tsNeverKeyword();
        case "AnyType": return t.tsAnyKeyword();
        case "ObjectType": return t.tsObjectKeyword();
        case "VoidType": return t.tsVoidKeyword();
        case "NumberType": return t.tsNumberKeyword();
        case "BigIntType": return t.tsBigIntKeyword();
        case "ObjectTypeLiteral": return tsTypeLiteral(ast);
        case "TupleType": return t.tsTupleType(ast.items.map(item => TSType(item)));
        case "ArrayType": return tsArrayType(ast);
        /**
         */
        case "TypeReference": return t.tsTypeReference(Identifier(ast.typeName));
        case "InferType": return t.tsInferType(t.tSTypeParameter(null, null, ast.typeName.name));
        case "TypeArrowFunctionExpression": return TSType(ast.body);
        case "TypeCallExpression": {
            const type = TSType(ast.callee);
            const params = ast.params.map(param => TSType(param));
            type.typeParameters = t.tsTypeParameterInstantiation(params);
            return type;
        }
        case "ConditionalTypeExpression": return tsConditionalType(ast.body);
        case "MappedTypeExpression": return tsMappedType(ast.body);
        case "UnionType": return t.tsParenthesizedType(t.tsUnionType(ast.types.map(each => TSType(each))));
        case "IntersectionType": return t.tsParenthesizedType(t.tsIntersectionType(ast.types.map(each => TSType(each))));
        case "KeyOfType": return tsTypeOperator(ast, "keyof");
        case "ReadonlyArray": return tsTypeOperator(ast, "readonly");
        case "ReadonlyTuple": return tsTypeOperator(ast, "readonly");
        case "IndexType": return tsIndexType(ast);
        case "FunctionType": return tsFunctionType(ast);
        case "ParenthesizedType": return t.tsParenthesizedType(TSType(ast.param));
        case "RestType": return t.tsRestType(TSType(ast.param));
        default:
            return assertNever(ast);
    }
}
exports.TSType = TSType;
function Identifier(ast) {
    return t.identifier(ast.name);
}
function assertNever(ast) {
    throw new Error("Unexpected ast: " + JSON.stringify(ast, null, 4));
}
const TypeLibFunction = {
    Object: {
        Assign: "object$assign",
    }
};
